































































import Vue from 'vue'
import citylist from '../../assets/js/selectCity.js'
import setting from '../../api/setting.js'
import oss from '../../api/oss.js'
import Cookie from 'js-cookie'
import Aplayer from 'vue-aplayer'
import tinymce from '@/components/Tinymce/index.vue'
import {HttpRequestOptions} from "element-ui/types/upload";
import {ElForm} from "element-ui/types/form";
interface Data {
    user: any;
    citylist: {
        p: any
    }[];
    citys: {
        n: any
    }[];
    cards: {
        id: number;
        card_url: string
    }[];
    rules: any

}
export default Vue.extend({
    data(): Data {
        let validatorNick = (rule: any, value: string, callback: any) => {
            if (!value) {
                return callback(new Error('昵称不能为空'))
            } else {
                let data = {
                    nickName: value,
                    user_id: (this as any).user.id
                };
                setting.verifyNick(data).then(response => {
                    callback()
                }).catch(e => {
                    callback(new Error('此昵称已存在，请换一个昵称'))
                })
            }
        };
        return {
            user: {},
            citylist,
            citys: [],
            cards: [],
            rules: {
                nickName: [
                    {
                        required: true, validator: validatorNick, trigger: 'blur'
                    }
                ]
            }
        }
    },
    components: {
        Aplayer,
        tinymce
    },
    methods: {
        getItem() {
            setting.getAccount().then(response => {
                let data = response.data.user
                data.user_id = data.id
                data.province = data.area.split('-')[0]
                data.city = data.area.split('-')[1]
                this.changePro(data.province);
                this.user = response.data.user
                this.cards = response.data.card;
            })
        },
        // 获取市
        changePro(val: string) {
            let items = citylist.filter(item => {
                return item.p == val
            })
            this.citys = items[0].c
        },
        uploadImg(param: HttpRequestOptions) {
            oss.putUseBucketImg(param.file).then(response => {
                this.user.portraitMini = response.url
            }).catch(err => {
                throw err
            })
        },
        submitForm() {
            (this.$refs['user'] as ElForm).validate((valid: boolean) => {
                if (valid) {
                    setting.setAccount(this.user).then(response => {
                        console.log(response.data)
                        Cookie.set('user', response.data.user);
                        this.$message({
                            message: '设置成功',
                            type: 'success'
                        })
                    })
                }
            })
        }
    },
    created() {
        this.getItem();
    }
})
